<template lang="pug">
.form-conveyor.center(:class="{'inside-padding': !fillData}")
  form(@submit.prevent="" autocomplete="off")
    h2.title {{ title }}
    .form-section
      .input-container
        input.input(v-model="dataForm.conveyor" autocomplete="ño" :disabled="fillData" required)
        label.label(:class="{ show: dataForm.conveyor }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="conveyor" title="Nombre de la Transportadora")

      .input-container
        input.input(v-model.number="dataForm.order" type="number" autocomplete="ño" required)
        label.label(:class="{ show: dataForm.order }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="order" title="Orden")

      .input-container
        input.input(v-model.number="dataForm.cost" min="0" max="150000" type="number" autocomplete="ño" required)
        label.label(:class="{ show: dataForm.cost >= 0 }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="cost" title="Costo")

      .input-container.arrow
        select.select(v-model="dataForm.folder" autocomplete="ño" required)
          option(v-for="folder in folders" :value="folder") {{ folder }}
        label.label(:class="{ show: dataForm.folder }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="folder" title="Carpeta")

      shInputImage(:dataForm="dataForm" :dataOriginal="dataOriginal" title="Imagen" property="image" :folder="dataForm.folder" @load="imageLoaded = true" @error="imageLoaded =  false" :noImagePath="noImagePathConveyor" :classContainerImage="classContainerImage" :imagePath="imagePath" :required="1")

      .left
        h3 Activo en Marca

      .input-container.arrow(v-for="(brand, index) in brands")
        select.select(v-model="dataForm.activeConveyor[index]" autocomplete="ño" required)
          option(:value="true") Activo
          option(:value="false") Inactivo
        label.label(:class="{ show: dataForm.activeConveyor[index] }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="activeConveyor" :index="index" :title="brand")

    shActionButton(:isForm="true" :text="fillData ? 'Actualizar' : 'Guardar'" :textRunning="fillData ? 'Actualizando' : 'Guardando'" :action="sendForm")

  .right(v-if="fillData")
    shDeleteButton(@delete="deleteConveyor")
</template>

<script>
import mForm from '@/mixins/form'
import mDB from '@/mixins/db'
import gqlConveyor from '@/graphql/conveyor'

export default {
  name: 'FormConveyor',

  mixins: [mForm, mDB],

  props: {
    title: String,
    fillData: Boolean,
    dataOriginal: Object
  },

  data () {
    return {
      dataForm: {
        conveyor: '',
        image: '',
        folder: '',
        order: '',
        cost: '',
        activeConveyor: [],
        activeBrands: []
      },
      resolver: 'conveyor',
      key: 'conveyor',
      gql: gqlConveyor,
      classContainerImage: 'button-conveyor'
    }
  },

  created () {
    if (this.fillData) this.dataForm = this.copyObject(this.dataOriginal)
  },

  methods: {
    sendForm () {
      if (!this.fillData) {
        this.newConveyor()
      } else {
        this.updateConveyor()
      }
    },

    newConveyor () {
      this.newData(this.gql, this.resolver, this.key)
    },

    updateConveyor () {
      this.updateData(this.gql, this.resolver, this.key)
    },

    deleteConveyor () {
      this.deleteData(this.gql, this.resolver, this.key)
    }
  },

  computed: {
    folders () {
      return this.$store.state.folders
    },
    brands () {
      return this.$store.state.variables.brands
    }
  },

  watch: {
    dataOriginal: {
      handler (val) {
        if (this.fillData) this.dataForm = this.copyObject(this.dataOriginal)
      },
      deep: true
    },
    brands (newVal) {
      if (!this.fillData) this.dataForm.activeBrands = newVal
    }
  }
}
</script>

<style lang="stylus">
.form-conveyor
  position relative

.button-conveyor
  border none
  border-radius 1em
  //borderRadius(.8em)
  font-size 1.2em
  font-weight 600
  transition all .2s ease-in
  box-shadow 0px 0px 20px -2px rgba(0, 0, 0, .9)
  display inline-flex
  padding .7em 1.3em
  justify-content space-around
  //boxShadow(0px 8px 20px -2px rgba(0, 0, 0, .9))

.button-conveyor:hover
  box-shadow 0px 0px 20px -2px #ffdc65

.button-conveyor img
  align-self center
  height 1.8em
</style>



// WEBPACK FOOTER //
// src/components/pages/conveyor/Form.vue